// src/components/ProtectedRoute.js
// بيحمي أي صفحة جواه - لو مفيش مستخدم مسجل دخول، يرجعه لصفحة اللوجين

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
